const captionCls = "_b7ncycxnv0";
const contentCls = "_b7nc1rv7unk";
const titleCls = "_b7nt1lk0u7f";
const spanCls = "_b7ns1k1r75p";

export { captionCls, contentCls, spanCls, titleCls };
import "./atom.slide-caption.style.linaria.module.css";
//# sourceMappingURL=atom.slide-caption.style.js.map
